<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card card-modern">
          <div class="card-header">
            <h2 class="card-title">Zaglavlje ponude</h2>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group row"
                  :class="{ 'has-danger': $v.offer.ordinalNumber.$anyError }"
                >
                  <label class="control-label mb-0">
                    Redni broj dokumenta
                  </label>
                  <input
                    type="number"
                    placeholder="Redni broj"
                    class="form-control form-control-modern"
                    v-model.number="offer.ordinalNumber"
                  />
                  <form-error
                    :model="$v.offer.ordinalNumber"
                    :dirty="$v.$dirty"
                    :label="'Redni broj dokumenta'"
                  />
                </div>
                <div
                  class="form-group row"
                  :class="{ 'has-danger': $v.offer.title.$anyError }"
                >
                  <label class="control-label mb-0"> Naziv ponude </label>
                  <input
                    type="text"
                    placeholder="Naziv"
                    class="form-control form-control-modern"
                    v-model="offer.title"
                  />
                  <form-error
                    :model="$v.offer.title"
                    :dirty="$v.$dirty"
                    :label="translations.forms.labels.title"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">Komitent</label>
                  <input
                    type="text"
                    placeholder="Komitent"
                    class="form-control form-control-modern"
                    v-model="offer.customer"
                  />
                  <form-error
                    :model="$v.offer.customer"
                    :dirty="$v.$dirty"
                    label="Komitent"
                  />
                </div>

                <div class="form-group">
                  <label class="control-label">Komercijalist</label>
                  <div class="select-padding">
                    <treeselect
                      :options="commercialists"
                      v-model="offer.commercialistId"
                    />
                  </div>
                  <form-error
                    :model="$v.offer.commercialistId"
                    :dirty="$v.$dirty"
                    label="Komercijalist"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group"
                  :class="{
                    'has-danger': $v.offer.documentCreationDate.$anyError,
                  }"
                >
                  <label class="control-label">Datum kreiranja ponude</label>
                  <div>
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                      <datepicker
                        placeholder="Datum kreiranja ponude"
                        v-model="offer.documentCreationDate"
                        input-class="form-control form-control-modern bg-body w-100"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                      <form-error
                        :model="$v.offer.documentCreationDate"
                        :dirty="$v.$dirty"
                        :label="'Datum kreiranja ponude'"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{
                    'has-danger': $v.offer.documentExpirationDate.$anyError,
                  }"
                >
                  <label class="control-label">Datum isteka ponude</label>
                  <div class="">
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                      <datepicker
                        placeholder="Datum isteka ponude"
                        v-model="offer.documentExpirationDate"
                        input-class="form-control form-control-modern bg-body w-100"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                      <form-error
                        :model="$v.offer.documentExpirationDate"
                        :dirty="$v.$dirty"
                        :label="'Datum isteka ponude'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label mb-0"> Prefix </label>
                  <input
                    type="text"
                    placeholder="Prefix"
                    class="form-control form-control-modern"
                    v-model="offer.prefix"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label mb-0"> Suffix </label>
                  <input
                    type="text"
                    placeholder="Suffix"
                    class="form-control form-control-modern"
                    v-model="offer.suffix"
                  />
                </div>
              </div>

              <div class="col-md-12 mt-2">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group row">
                      <label class="control-label mb-0"> Broj dokumenta </label>
                      <input
                        type="text"
                        placeholder="Broj dokumenta"
                        class="form-control form-control-modern"
                        readonly
                        :value="documentNumber"
                      />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="control-label mb-0"> Djelatnost </label>
                      <treeselect
                        :options="interestsAreas"
                        v-model="offer.interestAreaId"
                      />
                    </div>
                    <form-error
                      :model="$v.offer.interestAreaId"
                      :dirty="$v.offer.$dirty"
                      :label="'Djelatnost'"
                    />
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="control-label mb-0">Kreairao</label>
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        readonly
                        v-model="offer.author"
                      />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="control-label mb-0">Izmjenio</label>
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        readonly
                        v-model="offer.lastModifiedBy"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mt-3">
                      <label class="control-label mb-0"
                        >Prikaži izvještaj sa informacijama o kompaniji</label
                      >
                      <div class="d-inline p-2 pt-4">
                        <input
                          type="checkbox"
                          v-model="offer.displayCompanyInformation"
                          id="visible-on-web"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="action-buttons d-flex justify-content-between"
                style="margin-top: 2rem"
              >
                <div>
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                    class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                  >
                    <i class="bx bx-trash text-4 me-2"></i>
                    {{ translations.delete }}
                  </button>
                </div>
                <div class="d-flex gap-2">
                  <router-link
                    exact
                    :to="{ name: 'Offers' }"
                    class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
                  >
                    Otkaži
                  </router-link>
                  <button
                    type="submit"
                    class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                    @click="submitForm"
                  >
                    <i class="bx bx-save text-4 me-2"></i
                    >{{ translations.save }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <form @submit.prevent.stop="submitForm">
          <div class="row mt-4">
            <div class="col">
              <div class="card card-modern card-modern-table-over-header">
                <div class="card-header">
                  <div class="row align-items-center mb-5">
                    <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                      <a
                        href="#add-article"
                        data-bs-toggle="modal"
                        data-bs-target="#add-article"
                        class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                      >
                        + Dodaj stavku
                      </a>
                      <button
                        class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                        type="button"
                        @click.prevent.stop="showConfirmationModal"
                      >
                        - Ukloni stavku
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body table-offer-responsive">
                  <table
                    v-if="offer && offer.documentItems && offer.documentItems.length"
                    class="table table-offer table-ecommerce-simple table-borderless table-striped mb-0"
                    style="min-width: 640px"
                  >
                    <thead>
                      <tr>
                        <th width="30">
                          <input
                            type="checkbox"
                            class="select-all checkbox-style-1 p-relative top-2"
                            v-model="selectAll"
                          />
                        </th>
                        <th>RBR</th>
                        <th>Slika</th>
                        <th>Šifra</th>
                        <th>Naziv</th>
                        <th>Količina</th>
                        <th>VPC</th>
                        <th>Rabat</th>
                        <th>Vrijednost</th>
                        <th>Porez</th>
                        <th>Iznos</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in offer.documentItems"
                        :key="item.id"
                        class="hover-row"
                      >
                        <td width="30">
                          <input
                            type="checkbox"
                            class="checkbox-style-1 p-relative top-2"
                            :value="item.id"
                            v-model="selected"
                          />
                        </td>
                        <td @click.prevent.stop="editArticle(item)">
                          {{ item.ordinalNumber }}
                        </td>
                        <td @click.prevent.stop="editArticle(item)">
                          <div>
                            <img
                              :src="`${baseUrl}${item.imageUrl}`"
                              v-if="item.imageUrl"
                              class="product-img-thumb"
                            />
                            <img
                              v-else-if="item.articleId != null"
                              class="product-img-thumb"
                              :src="`${baseUrl}${item.highlightedImageThumbnailUrl || item.highlightedImageUrl}`"
                            />
                            <img
                              v-else
                              class="product-img-thumb"
                              :src="'img/products/product-8.jpg'"
                            />
                          </div>
                        </td>
                        <td @click.prevent.stop="editArticle(item)">
                          <strong>{{ item.code }}</strong>
                        </td>
                        <td @click.prevent.stop="editArticle(item)">
                          <strong>{{ item.title }}</strong>
                        </td>
                        <td>
                          {{ item.quantity }}
                          {{
                            measurementUnits.find(
                              ({ id }) => id === item.unitOfMeasureId
                            ).title
                          }}
                        </td>
                        <td @click.prevent.stop="editArticle(item)">{{ item.vpc | money2 }}</td>
                        <td @click.prevent.stop="editArticle(item)">{{ Number(item.discount1 || 0).toFixed(2) }} %</td>
                        <td @click.prevent.stop="editArticle(item)">{{ (item.amount * item.quantity) | money2 }}</td>
                        <td @click.prevent.stop="editArticle(item)">{{ item.taxAmount | money2 }}</td>
                        <td @click.prevent.stop="editArticle(item)">{{ item.totalAmount | money2 }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else>
                    <div class="alert alert-info" role="alert">
                      {{ translations.noRecords }}
                    </div>
                  </div>
                  <div
                    v-if="offer && offer.documentItems && offer.documentItems.length"
                    class="row"
                  >
                    <h4 class="font-weight-semibold py-4">
                      Ukupan iznos ponude: {{ offer.documentItems.reduce((sum, item) => sum + item.totalAmount, 0) | money2 }}
                    </h4>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mt-3">
                      <label class="control-label mb-0">Prikaži ukupan iznos na izvještaju</label>
                      <div class="d-inline p-2 pt-4">
                        <input
                          type="checkbox"
                          v-model="showTotalAmount"
                          id="show-toital-amount"
                        />
                      </div>
                    </div>
                  </div>
                  <hr class="solid mt-5 opacity-4" />
                  <div
                    class="datatable-footer"
                    v-if="offer && offer.documentItems && offer.documentItems.length > 4"
                  >
                    <div class="row align-items-center justify-content-between mt-3">
                      <div class="col-md-auto order-1 mb-3 mb-lg-0">
                        <div class="d-flex align-items-stretch">
                          <a
                            href="#add-article"
                            data-bs-toggle="modal"
                            data-bs-target="#add-article"
                            class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                          >+ Dodaj stavku</a>
                          <button
                            class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                            type="button"
                            @click.prevent.stop="showConfirmationModal"
                          >
                            - Ukloni stavku
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="action-buttons d-flex justify-content-end"
              style="margin-top: 2rem"
            >
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                  @click="copyOffer"
                >
                  <i class="bx bx-save text-4 me-2"></i>Kopiraj ponudu
                </button>
                <button
                  type="button"
                  class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                  @click="openReport"
                >
                  <i class="bx bx-file text-4 me-2"></i>Prikaži ponudu
                </button>
              </div>
            </div>
          </div>

          <!-- Delete offer modal -->
          <modal id="delete-modal">
            <h5 slot="header">
              <strong>Izbrišite ponudu</strong>
            </h5>
            <div slot="body">
              <span v-html="modalText"> </span>
            </div>
            <div slot="footer">
              <div class="row">
                <div class="col-md-12 text-end">
                  <button
                    type="button"
                    class="btn btn-primary px-4 mx-2"
                    @click.prevent.stop="deleteOffer"
                    data-bs-dismiss="modal"
                  >
                    {{ translations.yes }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-default px-4"
                    data-bs-dismiss="modal"
                  >
                    {{ translations.no }}
                  </button>
                </div>
              </div>
            </div>
          </modal>
        </form>

        <!-- Add article modal -->
        <modal id="add-article" cssClass="modal-xl modal-lg modal-md">
          <header slot="header">
            <h2 class="card-title">Dodavanje artikla</h2>
          </header>
          <section slot="body">
            <div class="card-body">
              <div class="form-group row">
                <label class="col-lg-1 control-label text-lg-end pt-2">
                  Pretraga
                </label>
                <div class="col-lg-10">
                  <div class="header-center">
                    <div class="header-search">
                      <div class="header-search-wrapper" ref="searchWrapper">
                        <input
                          type="search"
                          class="form-control"
                          placeholder="Unesite minimalno 3 karaktera"
                          v-model="searchInput"
                          @input="handleSearch"
                          @focus="handleFocus"
                          @blur="handleBlur()"
                        />
                        <ul
                          class="article-list bg-body"
                          v-if="showSearchResults"
                          @mousedown="onSearchResultsMouseDown"
                        >
                          <li
                            v-for="article in articles"
                            :key="article.id"
                            @click="
                              articleId = article.id;
                              selectArticle(article);
                              onArticleSelect('new');
                            "
                          >
                            <div class="article-wrapper">
                              <img
                                v-if="article.highlightedImageUrl"
                                :src="`${baseUrl}${article.highlightedImageThumbnailUrl || article.highlightedImageUrl}`"
                                class="article-image"
                              />
                              <img
                                v-else
                                class="article-image"
                                :src="'img/products/product-8.jpg'"
                              />
                              <div class="article-description">
                                <div class="article-title">
                                  {{ article.title }}
                                </div>
                                <div class="article-code">
                                  {{ article.code }}
                                </div>
                                <div class="article-price">
                                  {{ article.price | money2 }}
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <button class="btn" type="button">
                          <i class="icon-magnifier"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-12">
                  <div class="form-group row">
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="code">Šifra</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="code"
                        v-model="article.code"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.article.title.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="article-title">Artikal</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="article-title"
                        v-model="article.title"
                      />
                      <form-error
                        :model="$v.article.title"
                        :dirty="$v.article.$dirty"
                        :label="'Artikal'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.article.unitOfMeasureId.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="measure-unit">JMJ</label>
                    <div class="col-lg-9">
                      <select
                        class="form-control form-control-modern"
                        v-model="article.unitOfMeasureId"
                      >
                        <option :value="null">Izaberi jedinicu mjere</option>
                        <option
                          :value="unit.id"
                          :key="unit.id"
                          v-for="unit in measurementUnits"
                        >
                          {{ unit.description }}
                        </option>
                      </select>
                      <form-error
                        :model="$v.article.unitOfMeasureId"
                        :dirty="$v.article.$dirty"
                        :label="'JMJ'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.article.quantity.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="article-quantity">Količina</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="article-quantity"
                        v-model.number="article.quantity"
                        @input="onNewQuantityChange"
                        @blur="checkIsNull('article.quantity')"
                      />
                      <form-error
                        :model="$v.article.quantity"
                        :dirty="$v.article.$dirty"
                        :label="'Količina'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.article.vpc.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="vpc">VPC</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="vpc"
                        v-model="newVPCDisplay"
                        @focus="newVPCEditing = true; newVPCRaw = article.vpc == null ? '' : String(article.vpc)"
                        @blur="newVPCEditing = false; onNewVPCChange(); checkIsNull('article.vpc')"
                      />
                      <form-error
                        :model="$v.article.vpc"
                        :dirty="$v.article.$dirty"
                        :label="'VPC'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.article.discount1.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="">Rabat %</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        id="article-discount1"
                        class="form-control form-control-modern"
                        v-model="newDiscount1Display"
                        @focus="newDiscount1Editing = true; newDiscount1Raw = article.discount1 == null ? '' : String(article.discount1)"
                        @blur="newDiscount1Editing = false; onNewDiscountChange(); checkIsNull('article.discount1')"
                      />
                      <form-error
                        :model="$v.article.discount1"
                        :dirty="$v.article.$dirty"
                        :label="'Rabat %'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.article.amount.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2">VPC - Rabat</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        id="article-amount"
                        class="form-control form-control-modern"
                        v-model="newAmountDisplay"
                        @focus="newAmountEditing = true; newAmountRaw = article.amount == null ? '' : String(article.amount)"
                        @blur="newAmountEditing = false; onNewAmountChange(); checkIsNull('article.amount')"
                      />
                      <form-error
                        :model="$v.article.amount"
                        :dirty="$v.article.$dirty"
                        :label="'VPC - Rabat'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.article.taxAmount.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="">Porez 17%</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :value="(article.taxAmount || 0).toFixed(2)"
                        readonly
                      />
                      <form-error
                        :model="$v.article.taxAmount"
                        :dirty="$v.article.$dirty"
                        :label="'Porez 17%'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.article.totalAmount.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="total-amount">Iznos</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="total-amount"
                        :value="(article.totalAmount || 0).toFixed(2)"
                        readonly
                      />
                      <form-error
                        :model="$v.article.totalAmount"
                        :dirty="$v.article.$dirty"
                        :label="'Iznos'"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-8 col-12">
                  <div class="form-group row">
                    <label class="col-lg-1 control-label text-lg-end pt-2" for="description">Opis</label>
                    <div class="col-lg-11">
                      <editor
                        name="html-editor"
                        :init="{ ...appSettings.tinyMceConfig }"
                        v-model="article.description"
                        id="description"
                      ></editor>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-1 control-label text-lg-end mb-0">Slika</label>
                    <div class="col-lg-11">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photoAdd"
                        @change="handlePhotoAddUpload"
                        accept="image/*"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <footer slot="footer">
            <div class="row">
              <div class="col-md-12 text-end">
                <button
                  class="btn btn-default modal-dismiss mx-2"
                  aria-label="Close"
                  @click="closeModal"
                >
                  Odustani
                </button>
                <button
                  class="btn btn-primary modal-confirm"
                  @click="addArticleToOffer"
                >
                  Dodaj artikal
                </button>
              </div>
            </div>
          </footer>
        </modal>

        <!-- Edit article modal -->
        <modal
          id="edit-article"
          cssClass="modal-xl modal-lg modal-md"
          v-if="editingArticle"
          @close="closeEditModal"
        >
          <header slot="header">
            <h2 class="card-title">Ažuriranje artikla</h2>
          </header>
          <section slot="body">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4 col-12">
                  <div class="form-group row">
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="code">Redni broj</label>
                    <div class="col-lg-9">
                      <input
                        type="number"
                        class="form-control form-control-modern"
                        id="ordinalNumber"
                        v-model="editingArticle.ordinalNumber"
                        :blur="checkIfOrdinalNumberExists"
                      />
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="code">Šifra</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="code"
                        v-model="editingArticle.code"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.editingArticle.title.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="article-title">Artikal</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="article-title"
                        v-model="editingArticle.title"
                      />
                      <form-error
                        :model="$v.editingArticle.title"
                        :dirty="$v.editingArticle.$dirty"
                        :label="'Artikal'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.editingArticle.unitOfMeasureId.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="measure-unit">JMJ</label>
                    <div class="col-lg-9">
                      <select
                        class="form-control form-control-modern"
                        v-model="editingArticle.unitOfMeasureId"
                      >
                        <option :value="null">Izaberi jedinicu mjere</option>
                        <option
                          :value="unit.id"
                          :key="unit.id"
                          v-for="unit in measurementUnits"
                        >
                          {{ unit.description }}
                        </option>
                      </select>
                      <form-error
                        :model="$v.editingArticle.unitOfMeasureId"
                        :dirty="$v.editingArticle.$dirty"
                        :label="'JMJ'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.editingArticle.quantity.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="article-quantity">Količina</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="article-quantity"
                        v-model.number="editingArticle.quantity"
                        @input="onEditQuantityChange"
                        @blur="checkIsNull('editingArticle.quantity')"
                      />
                      <form-error
                        :model="$v.editingArticle.quantity"
                        :dirty="$v.editingArticle.$dirty"
                        :label="'Količina'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.editingArticle.vpc.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="vpc">VPC</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="vpc"
                        v-model="editVPCDisplay"
                        @focus="editVPCEditing = true; editVPCRaw = editingArticle.vpc == null ? '' : String(editingArticle.vpc)"
                        @blur="editVPCEditing = false; onEditVPCChange(); checkIsNull('editingArticle.vpc')"
                      />
                      <form-error
                        :model="$v.editingArticle.vpc"
                        :dirty="$v.editingArticle.$dirty"
                        :label="'VPC'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.editingArticle.discount1.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="">Rabat %</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="edit-discount"
                        v-model="editDiscount1Display"
                        @focus="editDiscount1Editing = true; editDiscount1Raw = editingArticle && editingArticle.discount1 != null ? String(editingArticle.discount1) : ''"
                        @blur="editDiscount1Editing = false; onEditDiscountChange(); checkIsNull('editingArticle.discount1')"
                      />
                      <form-error
                        :model="$v.editingArticle.discount1"
                        :dirty="$v.editingArticle.$dirty"
                        :label="'Rabat %'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.editingArticle.amount.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="">VPC - Rabat</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="edit-amount"
                        v-model="editAmountDisplay"
                        @focus="editAmountEditing = true; editAmountRaw = editingArticle && editingArticle.amount != null ? String(editingArticle.amount) : ''"
                        @blur="editAmountEditing = false; onEditAmountChange(); checkIsNull('editingArticle.amount')"
                      />
                      <form-error
                        :model="$v.editingArticle.amount"
                        :dirty="$v.editingArticle.$dirty"
                        :label="'VPC - Rabat'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.editingArticle.taxAmount.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="">Porez 17%</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :value="editingArticle.taxAmount.toFixed(2)"
                        id=""
                        readonly
                      />
                      <form-error
                        :model="$v.editingArticle.taxAmount"
                        :dirty="$v.editingArticle.$dirty"
                        :label="'Porez 17%'"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row"
                    :class="{ 'has-danger': $v.editingArticle.totalAmount.$anyError }"
                  >
                    <label class="col-lg-3 control-label text-lg-end pt-2" for="total-amount">Iznos</label>
                    <div class="col-lg-9">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        id="total-amount"
                        :value="(editingArticle.totalAmount || 0).toFixed(2)"
                        readonly
                      />
                      <form-error
                        :model="$v.editingArticle.totalAmount"
                        :dirty="$v.editingArticle.$dirty"
                        :label="'Iznos'"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-8 col-12">
                  <div class="form-group row">
                    <label class="col-lg-1 control-label text-lg-end pt-2" for="description">Opis</label>
                    <div class="col-lg-11">
                      <editor
                        name="html-editor"
                        :init="{ ...appSettings.tinyMceConfig }"
                        v-model="editingArticle.description"
                        id="description-edit"
                      ></editor>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-1 control-label text-lg-end mb-0">Slika</label>
                    <div class="col-lg-11">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        @change="handlePhotoUpload"
                        accept="image/*"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <footer slot="footer">
            <div class="row">
              <div class="col-md-12 text-end">
                <button
                  class="btn btn-primary modal-confirm"
                  @click="onEditArticleClose"
                >
                  Spremi
                </button>
              </div>
            </div>
          </footer>
        </modal>

        <!-- Confirm delete items modal -->
        <modal id="confirm-delete">
          <h5 slot="header">
            <strong>Ukloni odabrane artikle</strong>
          </h5>
          <div slot="body">
            Jeste li sigurni da želite ukloniti odabrane artikle?
          </div>
          <div slot="footer">
            <div class="row">
              <div class="col-md-12 text-end">
                <button
                  type="button"
                  class="btn btn-primary px-4 mx-2"
                  @click.prevent.stop="removeItemsFromOffer"
                  data-bs-dismiss="modal"
                >
                  {{ translations.yes }}
                </button>
                <button
                  type="button"
                  class="btn btn-default px-4"
                  data-bs-dismiss="modal"
                >
                  {{ translations.no }}
                </button>
              </div>
            </div>
          </div>
        </modal>

        <!-- Leave page confirmation modal -->
        <modal id="leave-page-modal">
          <h5 slot="header">
            <strong>Nesačuvane promjene</strong>
          </h5>
          <div slot="body">
            Jeste li sigurni da želite napustiti stranicu? Spremite ponudu prije napuštanja.
          </div>
          <div slot="footer">
            <div class="row">
              <div class="col-md-12 text-end">
                <button
                  type="button"
                  class="btn btn-primary px-4 mx-2"
                  @click.prevent.stop="confirmLeave"
                  data-bs-dismiss="modal"
                >
                  {{ translations.yes }}
                </button>
                <button
                  type="button"
                  class="btn btn-default px-4"
                  data-bs-dismiss="modal"
                >
                  {{ translations.no }}
                </button>
              </div>
            </div>
          </div>
        </modal>

      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import validations from './validation-schema/add';
import companyValidations from '../companies/validation-schema/add';
import addArticleValidations from './validation-schema/add-article';
import FormError from '../shared/form-errors/FormError.vue';

import { format } from 'date-fns';
import { debounce } from 'lodash';
import { translations, pager } from '@/mixins';
import Modal from '@/components/shared/modal/Modal.vue';
import editor from '@tinymce/tinymce-vue';

import config from '@/config';
import api from '@/services/api';
import helpers from '@/services/helpers';

const LEAVE_PAGE_MESSAGE =
  'Jeste li sigurni da želite napustiti stranicu? Spremite ponudu prije napuštanja';

export default {
  name: 'EditAdvancedOffer',
  mixins: [translations, pager],
  validations: {
    offer: validations,
    company: companyValidations,
    article: {
      ...addArticleValidations,
    },
    editingArticle: {
      ...addArticleValidations,
    },
  },
  components: {
    Datepicker,
    Treeselect,
    FormError,
    Modal,
    editor,
  },
  data() {
    return {
      selectedArticle: null,
      editingArticle: null,
      initialOfferSnapshot: null,
      isLeavingSafely: false,
      leavePageMessage: LEAVE_PAGE_MESSAGE,
      pendingNavigation: null,
      selected: [],
      searchInput: '',
      showSearchResults: false,
      articleId: null,
      documentTypeId: 1,
      ordinalNumber: 1,
      documentCreationDate: new Date(),
      documentExpirationDate: new Date(),
      description: '',
      title: '',
      deliveryDate: new Date(),
      paymentDate: new Date(),
      paymentType: 1,
      suffix: '',
      prefix: '',
      customerId: null,
      documentItems: [],
      commercialistId: null,
      interestAreaId: null,
      reportUrl: null,
      articleImageUrl: '',
      posterUrl: '',
      article: {
        id: null,
        highlightedImageUrl: '',
        imageUrl: '',
        unitOfMeasureId: null,
        taxId: null,
        title: '',
        quantity: 0,
        description: '',
        fc: 0,
        nc: 0,
        vpc: 0,
        mpc: 0,
        discount1: 0,
        totalAmount: 0,
        taxAmount: 0,
        code: '',
        amount: 0,
        totalAmountWithoutVat: 0,
        ordinalNumber: 0,
      },
      showTotalAmount: false,
      searchBlurTimer: null,
      searchResultsMouseDown: false,
      newVPCRaw: '',
      editVPCRaw: '',
      newVPCEditing: false,
      editVPCEditing: false,
      newDiscount1Editing: false,
      newAmountEditing: false,
      editDiscount1Editing: false,
      editAmountEditing: false,
      newDiscount1Raw: '',
      newAmountRaw: '',
      editDiscount1Raw: '',
      editAmountRaw: '',
    };
  },
  computed: {
    modalText() {
      return `Jeste li sigurni da želite obrisati ${this.offer?.title} ponudu?`;
    },
    newVPCDisplay: {
      get() {
        if (this.newVPCEditing) return this.newVPCRaw;
        if (this.article.vpc == null) return '';
        return Number(this.article.vpc).toFixed(2);
      },
      set(val) {
        this.newVPCRaw = val;
        const cleaned = String(val).replace(',', '.');
        if (cleaned === '' || cleaned === '-' || cleaned === '.') return;
        const num = Number(cleaned);
        if (!isNaN(num)) this.article.vpc = num;
      },
    },
    editVPCDisplay: {
      get() {
        if (!this.editingArticle) return '';
        if (this.editVPCEditing) return this.editVPCRaw;
        if (this.editingArticle.vpc == null) return '';
        return Number(this.editingArticle.vpc).toFixed(2);
      },
      set(val) {
        if (!this.editingArticle) return;
        this.editVPCRaw = val;
        const cleaned = String(val).replace(',', '.');
        if (cleaned === '' || cleaned === '-' || cleaned === '.') return;
        const num = Number(cleaned);
        if (!isNaN(num)) this.editingArticle.vpc = num;
      },
    },
    newDiscount1Display: {
      get() {
        if (this.newDiscount1Editing) return this.newDiscount1Raw;
        if (this.article.discount1 == null) return '';
        return Number(this.article.discount1).toFixed(2);
      },
      set(val) {
        this.newDiscount1Raw = val;
        const cleaned = String(val).replace(',', '.');
        if (cleaned === '' || cleaned === '-' || cleaned === '.') return;
        const num = Number(cleaned);
        if (!isNaN(num)) this.article.discount1 = num;
      },
    },
    newAmountDisplay: {
      get() {
        if (this.newAmountEditing) return this.newAmountRaw;
        if (this.article.amount == null) return '';
        return Number(this.article.amount).toFixed(2);
      },
      set(val) {
        this.newAmountRaw = val;
        const cleaned = String(val).replace(',', '.');
        if (cleaned === '' || cleaned === '-' || cleaned === '.') return;
        const num = Number(cleaned);
        if (!isNaN(num)) this.article.amount = num;
      },
    },
    editDiscount1Display: {
      get() {
        if (!this.editingArticle) return '';
        if (this.editDiscount1Editing) return this.editDiscount1Raw;
        if (this.editingArticle.discount1 == null) return '';
        return Number(this.editingArticle.discount1).toFixed(2);
      },
      set(val) {
        if (!this.editingArticle) return;
        this.editDiscount1Raw = val;
        const cleaned = String(val).replace(',', '.');
        if (cleaned === '' || cleaned === '-' || cleaned === '.') return;
        const num = Number(cleaned);
        if (!isNaN(num)) this.editingArticle.discount1 = num;
      },
    },
    editAmountDisplay: {
      get() {
        if (!this.editingArticle) return '';
        if (this.editAmountEditing) return this.editAmountRaw;
        if (this.editingArticle.amount == null) return '';
        return Number(this.editingArticle.amount).toFixed(2);
      },
      set(val) {
        if (!this.editingArticle) return;
        this.editAmountRaw = val;
        const cleaned = String(val).replace(',', '.');
        if (cleaned === '' || cleaned === '-' || cleaned === '.') return;
        const num = Number(cleaned);
        if (!isNaN(num)) this.editingArticle.amount = num;
      },
    },
    selectAll: {
      get: function () {
        return this.selected.length === this.offer.documentItems.length;
      },
      set: function (value) {
        const selected = [];
        if (value) {
          this.offer.documentItems.forEach(function ({ id }) {
            selected.push(id);
          });
        }
        this.selected = selected;
      },
    },
    paymentTypesArray() {
      return helpers.paymentTypesArray;
    },
    documentNumber() {
      return `${this.offer.prefix}${this.offer.ordinalNumber}${this.offer.suffix}`;
    },
    appSettings() {
      return config.appSettings;
    },
    baseUrl() {
      return config.baseUrl;
    },
    articles() {
      let articles = this.$store.getters.getArticles;
      articles.forEach((item) => {
        if (item.price && item.price < item.vpc) {
          item.quantity = item.quantity || 1;
          item.discount = item.discount || 100 * (1 - item.price / item.vpc);
          item.amount = item.price;
        }
      });
      return articles;
    },
    interestsAreas() {
      return this.$store.getters.getInterestsAreas.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    commercialists() {
      return this.$store.getters.getCommercialists.map(({ id, name }) => ({
        id,
        label: name,
      }));
    },
    bs() {
      return bs;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return { to: date };
    },
    measurementUnits() {
      return this.$store.getters.getMeasurementUnits;
    },
    offer() {
      let offer = this.$store.getters.getOffer;
      if (offer && offer.documentItems) {
        offer.documentItems.forEach((item) => {
          if (item.amount === undefined || item.amount === null) {
            item.amount = parseFloat(
              (item.vpc - item.vpc * (item.discount1 / 100)).toFixed(2)
            );
          }
          if (item.totalAmountWithoutVat === undefined || item.totalAmountWithoutVat === null) {
            item.totalAmountWithoutVat = parseFloat(
              (item.amount * item.quantity).toFixed(2)
            );
          }
        });
      }
      return offer;
    },
  },
  methods: {
    normalizeDate(value) {
      if (!value) return null;
      return helpers.formatDateForApi(value);
    },
    serializeDocumentItem(item = {}) {
      return {
        id: item.id || null,
        articleId: item.articleId || null,
        unitOfMeasureId: item.unitOfMeasureId || null,
        taxId: item.taxId || null,
        ordinalNumber: item.ordinalNumber || 0,
        title: item.title || '',
        quantity: item.quantity || 0,
        description: item.description || '',
        imageUrl: item.imageUrl || '',
        imageFileName: item.image?.fileName || null,
        fc: item.fc || 0,
        nc: item.nc || 0,
        vpc: item.vpc || 0,
        mpc: item.mpc || 0,
        discount1: item.discount1 || 0,
        totalAmount: item.totalAmount || 0,
        taxAmount: item.taxAmount || 0,
        code: item.code || '',
        amount: item.amount || 0,
        totalAmountWithoutVat: item.totalAmountWithoutVat || 0,
      };
    },
    serializeOfferState() {
      const offer = this.offer || {};
      return JSON.stringify({
        id: offer.id || null,
        ordinalNumber: offer.ordinalNumber || 0,
        documentTypeId: offer.documentTypeId || null,
        documentCreationDate: this.normalizeDate(offer.documentCreationDate),
        documentExpirationDate: this.normalizeDate(offer.documentExpirationDate),
        description: offer.description || '',
        title: offer.title || '',
        deliveryDate: this.normalizeDate(offer.deliveryDate),
        paymentDate: this.normalizeDate(offer.paymentDate),
        paymentType: offer.paymentType || null,
        suffix: offer.suffix || '',
        prefix: offer.prefix || '',
        customer: offer.customer || '',
        commercialistId: offer.commercialistId || null,
        displayCompanyInformation: Boolean(offer.displayCompanyInformation),
        interestAreaId: offer.interestAreaId || null,
        documentItems: (offer.documentItems || []).map((item) =>
          this.serializeDocumentItem(item)
        ),
      });
    },
    captureInitialState() {
      if (!this.offer?.id) return;
      this.initialOfferSnapshot = this.serializeOfferState();
      this.isLeavingSafely = false;
    },
    hasUnsavedChanges() {
      if (!this.initialOfferSnapshot || !this.offer?.id) return false;
      return this.serializeOfferState() !== this.initialOfferSnapshot;
    },
    shouldWarnBeforeLeaving() {
      return !this.isLeavingSafely && this.hasUnsavedChanges();
    },
    handleBeforeUnload(event) {
      if (!this.shouldWarnBeforeLeaving()) return;
      event.preventDefault();
      event.returnValue = this.leavePageMessage;
      return this.leavePageMessage;
    },
    confirmLeave() {
      if (this.pendingNavigation) {
        this.isLeavingSafely = true;
        this.pendingNavigation();
        this.pendingNavigation = null;
      }
    },
    refreshOffer() {
      return this.$store
        .dispatch('getAdvancedOffer', parseInt(this.$route.params.id, 10))
        .then(() => {
          this.captureInitialState();
        });
    },
    onEditArticleClose() {
      this.$v.editingArticle.$touch();
      if (this.$v.editingArticle.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        return;
      }

      if (this.posterUrl != '') {
        this.editingArticle.imageUrl = this.posterUrl;
        if (this.$refs.photo.files[0]) {
          const file = this.$refs.photo.files[0];
          this.editingArticle.image = {
            file: this.articleImageUrl.split(',')[1],
            fileName: file.name,
          };
        }
        this.$refs.photo.value = '';
        this.posterUrl = '';
        this.articleImageUrl = '';
      }

      api.updateOfferItem(this.editingArticle).then(() => {
        this.refreshOffer().then(() => {
          this.editingArticle = null;
          this.$v.editingArticle.$reset();
          $('#edit-article').modal('hide');
        });
      });
    },
    handlePhotoAddUpload() {
      const file = this.$refs.photoAdd.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const img = new Image();
      img.src = URL.createObjectURL(file);
      reader.onload = (e) => {
        this.articleImageUrl = e.target.result;
      };
      img.onload = () => {
        this.posterUrl = img.src;
      };
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const img = new Image();
      img.src = URL.createObjectURL(file);
      reader.onload = (e) => {
        this.articleImageUrl = e.target.result;
      };
      img.onload = () => {
        this.posterUrl = img.src;
      };
    },
    resetArticle() {
      this.article = {
        id: null,
        highlightedImageUrl: '',
        unitOfMeasureId: null,
        taxId: null,
        title: '',
        quantity: 0,
        description: '',
        fc: 0,
        nc: 0,
        vpc: 0,
        mpc: 0,
        discount1: 0,
        totalAmount: 0,
        taxAmount: 0,
        code: '',
        amount: 0,
        totalAmountWithoutVat: 0,
        ordinalNumber: 0,
      };
    },
    generateGUID() {
      return crypto.randomUUID();
    },
    openReport() {
      this.submitForm(false).then(() => {
        const apiUrl = localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL;
        this.reportUrl = `${apiUrl}/reports/offers/${parseInt(this.$route.params.id, 10)}/${this.showTotalAmount}`;
        window.open(this.reportUrl, '_blank');
      });
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    addArticleToOffer() {
      this.$v.article.$touch();
      if (this.$v.article.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        return;
      }

      this.$store.commit('SET_ARTICLES', []);
      this.article.ordinalNumber = this.offer.documentItems.length + 1;
      this.article.articleId = this.article.id;
      this.article.totalAmountWithoutVat = this.article.totalAmount - this.article.taxAmount;

      if (this.posterUrl != '') {
        this.article.imageUrl = this.posterUrl;
        if (this.$refs.photoAdd.files[0]) {
          const file = this.$refs.photoAdd.files[0];
          this.article.image = {
            file: this.articleImageUrl.split(',')[1],
            fileName: file.name,
          };
        }
        this.$refs.photoAdd.value = '';
        this.posterUrl = '';
        this.articleImageUrl = '';
      }

      $('#add-article').modal('hide');
      api.advancedUpdateOfferItems(this.offer.id, this.article).then(() => {
        this.refreshOffer().then(() => {
          this.articleId = null;
          this.resetArticle();
          this.$v.article.$reset();
        });
      });
    },
    copyOffer() {
      let copiedOffer = { ...this.offer };

      api.getNextOrdinalNumber().then(({ data }) => {
        copiedOffer.ordinalNumber = data.data;
      });

      copiedOffer.totalAmount = copiedOffer.documentItems.reduce(
        (prev, current) => prev + current.totalAmount,
        0
      );
      copiedOffer.title = copiedOffer.title + ' - Copy';
      copiedOffer.documentItems = copiedOffer.documentItems.map((item) => {
        item.articleImageUrl = item.imageUrl;
        return item;
      });
      copiedOffer.documentCreationDate = helpers.formatDateForApi(new Date());
      copiedOffer.documentExpirationDate = helpers.formatDateForApi(copiedOffer.documentExpirationDate);
      copiedOffer.deliveryDate = helpers.formatDateForApi(copiedOffer.deliveryDate);
      copiedOffer.paymentDate = helpers.formatDateForApi(copiedOffer.paymentDate);

      setTimeout(() => {
        api
          .createAdvancedOffer(copiedOffer)
          .then((response) => {
            this.$toast.info('Ponuda uspješno kopirana.');
            if (response.data.isValid == true) {
              this.isLeavingSafely = true;
              this.$router.push({
                name: 'EditAdvancedOffer',
                params: { id: response.data.data },
              });
            }
          })
          .catch(() => {
            this.$toast.error('Došlo je do pogreške prilikom kopiranja ponude.');
          });
      }, 1000);
    },
    submitForm(redirect = true) {
      const { offer } = this;

      this.$v.offer.$touch();
      if (this.$v.offer.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        this.$nextTick(() => {
          let elem = document.querySelector('.has-danger');
          elem.scrollIntoView(true);
        });
        return;
      }

      offer.totalAmount = offer.documentItems.reduce(
        (prev, current) => prev + current.totalAmount,
        0
      );

      const payload = {
        ...offer,
        documentCreationDate: this.normalizeDate(offer.documentCreationDate),
        documentExpirationDate: this.normalizeDate(offer.documentExpirationDate),
        deliveryDate: this.normalizeDate(offer.deliveryDate),
        paymentDate: this.normalizeDate(offer.paymentDate),
      };

      return api.updateAdvancedOffer(payload).then((response) => {
        this.$toast.info(response.data.info);
        this.captureInitialState();
        if (redirect) {
          this.isLeavingSafely = true;
          this.$router.push({ name: 'AdvancedOffers' });
        }
        return response;
      });
    },
    editArticle(item) {
      this.selectedArticle = item;
      this.editingArticle = JSON.parse(JSON.stringify(item));
      this.editDiscount1Editing = false;
      this.editAmountEditing = false;
      this.editDiscount1Raw = '';
      this.editAmountRaw = '';
      setTimeout(() => {
        $('#edit-article').modal('show');
      }, 100);
    },
    showConfirmationModal() {
      if (this.selected.length) $('#confirm-delete').modal('show');
    },
    onSearchResultsMouseDown() {
      this.searchResultsMouseDown = true;
    },
    onDocumentMouseUp() {
      if (this.searchResultsMouseDown) {
        this.searchResultsMouseDown = false;
      }
    },
    onDocumentMouseDown(event) {
      if (!this.showSearchResults) return;
      const wrapper = this.$refs.searchWrapper;
      if (wrapper && wrapper.contains(event.target)) return;
      this.showSearchResults = false;
    },
    closeEditModal() {
      this.refreshOffer().then(() => {
        this.editingArticle = null;
        $('#edit-article').modal('hide');
      });
    },
    closeModal() {
      this.articleId = null;
      $('#add-article').modal('hide');
    },
    removeItemsFromOffer() {
      api.deleteOfferItems(this.offer.id, this.selected).then(() => {
        this.$toast.info('Stavke uspješno obrisane.');
        this.refreshOffer();
      });
    },
    handleFocus() {
      if (this.searchBlurTimer) {
        clearTimeout(this.searchBlurTimer);
        this.searchBlurTimer = null;
      }
      if (this.searchInput.trim().length < 3) {
        this.showSearchResults = false;
        return;
      }
      this.showSearchResults = true;
      this.handleSearch();
    },
    handleBlur() {
      if (this.searchBlurTimer) {
        clearTimeout(this.searchBlurTimer);
      }
      const ignoreBlur = this.searchResultsMouseDown;
      this.searchBlurTimer = setTimeout(() => {
        if (ignoreBlur) {
          this.searchBlurTimer = null;
          return;
        }
        this.showSearchResults = false;
        this.searchResultsMouseDown = false;
        this.searchBlurTimer = null;
      }, 250);
    },
    handleSearch: debounce(function search() {
      const quickSearch = this.searchInput.trim();
      if (quickSearch.length < 3) {
        this.showSearchResults = false;
        return;
      }
      this.showSearchResults = true;
      this.$store.dispatch('getArticles', {
        sortBy: 'title',
        isSortAscending: false,
        page: 1,
        pageSize: 20,
        quickSearch,
        brandIds: [],
        categoryIds: [],
        attributeValuesIds: [],
        tagIds: [],
        customerId: this.offer.customerId,
        forDocument: true,
      });
    }, 300),
    onNewQuantityChange() {
      this.changeTotalAmountOfNewArticle();
    },
    round2(val) {
      return Number(val);
    },
    onNewVPCChange() {
      let { vpc, discount1 } = this.article;
      vpc = vpc || 0;
      discount1 = discount1 || 0;
      this.article.amount = this.round2(vpc - vpc * (discount1 / 100));
      this.changeTotalAmountOfNewArticle();
    },
    onNewDiscountChange() {
      let vpc = Number(this.article.vpc) || 0;
      let discount1 = Number(this.article.discount1) || 0;
      this.article.amount = this.round2(vpc - vpc * (discount1 / 100));
      this.changeTotalAmountOfNewArticle();
    },
    onNewAmountChange() {
      let amount = Number(this.article.amount) || 0;
      let vpc = Number(this.article.vpc) || 0;
      if (amount > vpc) this.article.amount = vpc;
      if (vpc > 0) {
        this.article.discount1 = this.round2(100 * (1 - amount / vpc));
      } else {
        this.article.discount1 = 0;
      }
      this.changeTotalAmountOfNewArticle();
    },
    onEditQuantityChange() {
      this.changeTotalAmountOfEditArticle();
    },
    onEditVPCChange() {
      let vpc = Number(this.editingArticle.vpc) || 0;
      let discount1 = Number(this.editingArticle.discount1) || 0;
      this.editingArticle.amount = this.round2(vpc - vpc * (discount1 / 100));
      this.changeTotalAmountOfEditArticle();
    },
    onEditAmountChange() {
      let amount = Number(this.editingArticle.amount) || 0;
      let vpc = Number(this.editingArticle.vpc) || 0;
      if (amount > vpc) this.editingArticle.amount = vpc;
      if (vpc > 0) {
        this.editingArticle.discount1 = this.round2(100 * (1 - amount / vpc));
      } else {
        this.editingArticle.discount1 = 0;
      }
      this.changeTotalAmountOfEditArticle();
    },
    onEditDiscountChange() {
      let vpc = Number(this.editingArticle.vpc) || 0;
      let discount1 = Number(this.editingArticle.discount1) || 0;
      this.editingArticle.amount = this.round2(vpc - vpc * (discount1 / 100));
      this.changeTotalAmountOfEditArticle();
    },
    checkIsNull(property) {
      if (property === 'article.vpc' && !this.article.vpc) {
        this.article.vpc = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.quantity' && !this.article.quantity) {
        this.article.quantity = 1;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.discount1' && !this.article.discount1) {
        this.article.discount1 = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.amount' && !this.article.amount) {
        this.article.amount = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'editingArticle.vpc' && !this.editingArticle.vpc) {
        this.editingArticle.vpc = 0;
        this.changeTotalAmountOfEditArticle();
      } else if (property === 'editingArticle.quantity' && !this.editingArticle.quantity) {
        this.editingArticle.quantity = 1;
        this.changeTotalAmountOfEditArticle();
      } else if (property === 'editingArticle.discount1' && !this.editingArticle.discount1) {
        this.editingArticle.discount1 = 0;
        this.changeTotalAmountOfEditArticle();
      } else if (property === 'editingArticle.amount' && !this.editingArticle.amount) {
        this.editingArticle.amount = 0;
        this.changeTotalAmountOfEditArticle();
      }
    },
    checkIfOrdinalNumberExists(ordinalNumber) {
      if (this.offer.documentItems.some((item) => item.ordinalNumber === ordinalNumber)) {
        this.$toast.error(`Artikal sa rednim brojem ${ordinalNumber} već postoji.`);
        this.editingArticle.ordinalNumber = 0;
      }
    },
    onArticleSelect(type) {
      if (type === 'new') {
        if (!this.article.vpc) this.article.vpc = 0;
        if (!this.article.quantity) this.article.quantity = 1;
        if (!this.article.discount1) this.article.discount1 = 0;
        this.article.amount = parseFloat(
          (this.article.vpc - this.article.vpc * (this.article.discount1 / 100)).toFixed(2),
          10
        );
        this.changeTotalAmountOfNewArticle();
      }
    },
    changeTotalAmountOfNewArticle() {
      let { quantity } = this.article;
      this.article.totalAmount = parseFloat(
        (this.article.amount * 1.17 * (quantity || 0)).toFixed(2),
        10
      );
      this.article.taxAmount = this.article.amount * 0.17 * (quantity || 0);
      this.article.totalAmountWithoutVat = this.article.totalAmount - this.article.taxAmount;
    },
    changeTotalAmountOfEditArticle() {
      let { quantity } = this.editingArticle;
      this.editingArticle.totalAmount = parseFloat(
        (this.editingArticle.amount * 1.17 * (quantity || 0)).toFixed(2),
        10
      );
      this.editingArticle.taxAmount = this.editingArticle.amount * 0.17 * (quantity || 0);
      this.editingArticle.totalAmountWithoutVat =
        this.editingArticle.totalAmount - this.editingArticle.taxAmount;
    },
    deleteOffer() {
      api
        .deleteOffers([this.offer.id])
        .then(() => {
          this.$toast.info('Ponuda uspješno izbrisana.');
          this.isLeavingSafely = true;
          this.$router.push({ name: 'AdvancedOffers' });
        })
        .catch((err) => {
          this.$toast.error(err.response?.data?.info);
        });
    },
    selectArticle(article) {
      this.article = {
        id: article.id || null,
        highlightedImageUrl: article.highlightedImageUrl || '',
        highlightedImageThumbnailUrl: article.highlightedImageThumbnailUrl || '',
        unitOfMeasureId: article.unitOfMeasureId,
        taxId: article.taxId || null,
        title: article.title || '',
        quantity: article.quantity || 0,
        description: article.description || '',
        fc: article.fc || 0,
        nc: article.nc || 0,
        vpc: article.vpc || 0,
        mpc: article.mpc || 0,
        discount1: article.discount1 || 0,
        totalAmount: article.totalAmount || 0,
        taxAmount: article.taxAmount || 0,
        code: article.code || '',
        amount: article.amount || 0,
        totalAmountWithoutVat: (article.totalAmount || 0) - (article.taxAmount || 0),
        ordinalNumber: article.ordinalNumber || 0,
      };
    },
    onMounted() {
      const apiUrl = localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL;
      this.reportUrl = `${apiUrl}/reports/offers/${parseInt(this.$route.params.id, 10)}/${this.showTotalAmount}`;

      return Promise.all([
        this.refreshOffer(),
        this.$store.dispatch('getMeasurementUnits', {
          sortBy: 'title',
          isSortAscending: true,
          retrieveAll: true,
        }),
        this.$store.dispatch('getInterestsAreas', {
          ...this.searchConfig,
          retrieveAll: true,
        }),
        this.$store.dispatch('getCommercialists'),
      ]);
    },
  },
  mounted() {
    this.onMounted();
    document.addEventListener('mousedown', this.onDocumentMouseDown);
    document.addEventListener('mouseup', this.onDocumentMouseUp);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown);
    document.removeEventListener('mouseup', this.onDocumentMouseUp);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown);
    document.removeEventListener('mouseup', this.onDocumentMouseUp);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (!this.shouldWarnBeforeLeaving()) {
      next();
      return;
    }
    this.pendingNavigation = next;
    this.$nextTick(() => {
      $('#leave-page-modal').modal('show');
    });
    next(false);
  },
  watch: {
    documentItems() {
      this.selected = [];
    },
    '$route.params.id': {
      handler() {
        this.onMounted();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.hover-row:hover {
  background-color: #f5f5f5;
  transition: background 0.2s;
}

.product-img-thumb {
  width: 70px;
  height: auto;
}

.table-offer td {
  padding-bottom: 0;
  padding-top: 0;
}

.select-padding {
  padding: 0;
}

.form-group + .form-group {
  border-top: none;
}

.form-control.form-control-modern
  + .select2-container--bootstrap
  .select2-selection--single,
.form-control.form-control-modern
  + .select2-container--bootstrap
  .select2-selection--multiple {
  border-color: #e7e7e7;
  line-height: 2.8;
  height: 45px;
  padding: 3px 24px 6px 17px;
}

.select2-container--bootstrap.select2-container--focus .select2-selection,
.select2-container--bootstrap.select2-container--open .select2-selection {
  border-color: #33bbff !important;
  box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset, 0 0 8px rgb(0 136 204 / 30%) !important;
}

.select2-container--bootstrap {
  width: 100% !important;
}

.modal-md-2.modal-dialog {
  min-width: 620px;

  .card-body {
    padding: 0 0.5em;
    box-shadow: none;
  }
}

.modal-lg-2.modal-dialog {
  min-width: 1250px;

  .card-body {
    padding: 0 0.5em;
    box-shadow: none;
  }
}

#add-company > .modal-dialog {
  min-width: 1000px !important;
}

.vdp-datepicker {
  width: calc(100% - 40px);

  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.vue-treeselect {
  min-height: 44px;
}

.vue-treeselect__control {
  min-height: 44px;
}

.vue-treeselect__value-container {
  min-height: 44px;
}

.header-center {
  position: relative;
}

.article-list {
  position: absolute;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  list-style: none;
  padding: 0;
  z-index: 1020;
  left: 0;
  top: 40px;
  width: 100%;
  background: #fff;
  max-height: 450px;
  overflow-y: auto;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 5px;
    cursor: pointer;
    overflow: hidden;
    opacity: 0.75;

    &:first-child {
      border-top: none;
    }

    &:hover {
      opacity: 1;
      .article-title {
        color: #259ddf;
        text-decoration: underline;
      }
    }
  }
}

.article-wrapper {
  display: flex;
  flex-basis: 50%;
}

.article-description {
  display: flex;
  flex-direction: column;
  height: 80px;
  color: #777;
}

.article-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 5px;
}

.product-image {
  display: block;
  width: 70px;
  height: 70px;
}

.product-image-container {
  margin-right: 5px;
}

.article-title,
.article-code,
.article-price {
  width: 100%;
  font-size: 16px;
  flex-basis: 50%;
}
</style>
